export type Flow = 'teacher' | 'school' | 'family'
export type Term = 'annual' | 'sprint'
export type Tier = 'pro' | 'premium'

// Which plan the buyer is configuring: a flow (teacher/family) plus a tier (pro/premium).
export interface Selection {
  flow: Flow
  tier: Tier
}

// One segment of the Annual / Sprint toggle.
export interface TermOption {
  term: Term
  price: string
}

export type PurchaseType =
  | 'homeschool'
  | 'homeschoolpro'
  | 'classroom'
  | 'classroompro'
  | 'school'
  | 'schoolpro'
  | 'one-seat'
  | 'fifty-seats'

// The Pro and Premium license types the backend expects for each flow. Pro is a distinct license
// type (classroompro/homeschoolpro/schoolpro), matching the shared LicenseType model.
export const FLOW_TYPES: Record<
  Flow,
  { pro: PurchaseType; premium: PurchaseType }
> = {
  teacher: { pro: 'classroompro', premium: 'classroom' },
  family: { pro: 'homeschoolpro', premium: 'homeschool' },
  school: { pro: 'schoolpro', premium: 'school' },
}

// Mirrors the server `PricesList` entry shape (shared/accounts/account-types.ts).
export interface PriceEntry {
  item: string
  price: string
  numSeats: number
  sku: string
  endsAt?: number
  termLength?: number
  discountedFrom?: string
  discountMessage?: string
  seatPrice?: string
  // What a school that already holds a licence pays, when that differs from the quoted price.
  existingCustomerPrice?: string
}

export type PricesList = Partial<Record<PurchaseType, PriceEntry>>
